import React from 'react';

export const ClientFields = ({ values, onChange, disabled = false }) => {
  return (
    <div className="quote-fields-grid">
      <label className="quote-field">
        <span>Nombre de la empresa*</span>
        <input
          type="text"
          name="companyName"
          value={values.companyName}
          onChange={onChange}
          disabled={disabled}
          required
        />
      </label>

      <label className="quote-field">
        <span>Nombre del contacto*</span>
        <input
          type="text"
          name="contactName"
          value={values.contactName}
          onChange={onChange}
          disabled={disabled}
          required
        />
      </label>

      <label className="quote-field">
        <span>Correo electronico*</span>
        <input
          type="email"
          name="email"
          value={values.email}
          onChange={onChange}
          disabled={disabled}
          required
        />
      </label>

      <label className="quote-field">
        <span>Telefono*</span>
        <input
          type="tel"
          name="phone"
          value={values.phone}
          onChange={onChange}
          disabled={disabled}
          required
        />
      </label>

      <label className="quote-field">
        <span>Pais / ciudad*</span>
        <input
          type="text"
          name="location"
          value={values.location}
          onChange={onChange}
          disabled={disabled}
          required
        />
      </label>
    </div>
  );
};

export const QuoteRequestFields = ({
  values,
  onChange,
  onFileChange,
  disabled = false,
}) => {
  return (
    <div className="quote-fields-grid quote-request-fields">
      <label className="quote-field">
        <span>Escriba su cotizacion</span>
        <textarea
          name="message"
          value={values.message}
          onChange={onChange}
          disabled={disabled}
          placeholder="Escriba aqui su respuesta..."
          rows={4}
        />
      </label>

      <label className={`quote-upload ${disabled ? 'disabled' : ''}`}>
        <input
          type="file"
          name="attachment"
          onChange={onFileChange}
          disabled={disabled}
        />
        <strong>Elige el archivo o arrastra aqui</strong>
        <span>Limite de tamano: 10MB</span>
      </label>
    </div>
  );
};
